export default __webpack_public_path__ + "static/insummary-419d82e8c6e670f9a4465574413548bf.webp";